export const SolutionResolutionFieldView = ({ captionText, valueText }) => (
  <div className="caption-style">
    <span data-testid="span" className="caption-text">{captionText} </span>
    <span data-testid="span" className="value-text">{valueText}</span>
  </div>
);
